module.exports = __webpack_public_path__ + "img/ry3.d713a51b.jpg";